import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Typography, Tabs, Button, Icon, Modal, DatePicker, message, Input } from "antd";
import moment from "moment";
import CardComplaintsTable from "./CardComplaintsTable";
import {
	fetchInaamCardLinkRequestListApi,
	exportCardLinkRequestsApi,
	resolveInaamCardLinkRequestApi,
	fetchInaamCardLinkRequestCountApi,
} from "utils/apiService.js";

import Loader from "../../components/Loader/Loader";
import Empty from "./Empty";

const { TabPane } = Tabs;
const { Text } = Typography;
const { RangePicker } = DatePicker;

export default function CardLinkRequest(props) {
	const [loading, setLoading] = useState(true);
	const [tableLoading, setTableLoading] = useState(false);

	const [resolveModal, setResolveModal] = useState(false);

	const [exportReportModal, setExportReportModal] = useState(false);
	const [exportReportDate, setExportReportDate] = useState({
		start_date: "",
		end_date: "",
	});

	const [searchKey, setSearchKey] = useState("");

	const [pendingData, setPendingData] = useState({
		cardLinkRequests: [],
		pageNum: 1,
		pageSize: 50,
		totalPages: 1,
	});
	const [resolvedData, setResolvedData] = useState({
		cardLinkRequests: [],
		pageNum: 1,
		pageSize: 50,
		totalPages: 1,
	});
	const [cardLinkStats, setCardLinkStats] = useState({
		pending: 0,
		resolved: 0,
	});
	// const [data, setData] = useState({
	// 	pendingCardLinkRequest: [],
	// 	resolvedCardLinkRequests: [],
	// });

	const [selectedRowIDs, setSelectedRowIDs] = useState([]);
	const handleRowSelection = (selectedRows) => {
		setSelectedRowIDs(selectedRows);
	};

	const activeKey = useRef("1");

	const fetchInaamCardLinkRequestList = () => {
		setTableLoading(true);
		fetchInaamCardLinkRequestListApi({
			requestData: {
				search_key: searchKey,
				status: activeKey.current === "1" ? "unresolved" : "resolved",
				page: activeKey.current === "1" ? pendingData.pageNum : resolvedData.pageNum,
			},
			resCallback: () => {
				loading && setLoading(false);
				setTableLoading(false);
			},
			res200Callback: (res) => {
				let dataList = res.data.card_link_request_list?.map((data) => ({ ...data, key: data.uuid }));
				activeKey.current === "1"
					? setPendingData({ ...pendingData, cardLinkRequests: dataList, totalPages: res.data.totalPages })
					: setResolvedData({ ...resolvedData, cardLinkRequests: dataList, totalPages: res.data.totalPages });
			},
		});
		fetchInaamCardLinkRequestCountApi({
			resCallback: () => {
				loading && setLoading(false);
			},
			res200Callback: (res) => {
				setCardLinkStats({ pending: res.data?.in_queue, resolved: res.data?.resolved });
			},
		});
	};

	const createReport = () => {
		message.loading("Exporting card link requests...", 1);
		exportCardLinkRequestsApi({
			requestData: exportReportDate,
			resCallback: () => {
				setExportReportModal(false);
			},
			res200Callback: () => {
				message.success("Card Link requests exported successfully.", 1);
			},
			resErrorCallback: () => {
				message.error("Failed while exporting the report!", 1);
			},
		});
	};

	useEffect(() => {
		fetchInaamCardLinkRequestList();
	}, [pendingData.pageNum, resolvedData.pageNum, searchKey]);

	return loading ? (
		<div
			style={{
				minHeight: "100vh",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				backgroundColor: "#FAFAFA",
			}}>
			<Loader />
		</div>
	) : cardLinkStats.pending + cardLinkStats.resolved === 0 ? (
		<Empty />
	) : (
		<>
			<Row
				style={{
					width: "100%",
					padding: "40px 25px 0px 25px",
					margin: "60px 0 0",
					backgroundColor: "#FAFAFA",
				}}
				gutter={[12, 48]}>
				<Row type="flex" justify="space-between">
					<Text style={{ color: "#181818", /*fontFamily: "Gotham",*/ fontStyle: "normal", fontWeight: "bold", fontSize: "24px", lineHeight: "39px" }}>
						Card Link Requests
					</Text>
					<div style={{ display: "flex" }}>
						<Input
							style={{
								marginRight: "8px",
								width: "275px",
								border: "1px solid rgb(0, 0, 0, 0.25)",
								borderRadius: "5px",
								alignItems: "left",
							}}
							value={searchKey}
							placeholder="Search Card Link Request"
							onChange={(e) => {
								setSearchKey(e.target.value);
								setPendingData({ ...pendingData, pageNum: 1 });
								setResolvedData({ ...resolvedData, pageNum: 1 });
							}}
							prefix={<Icon type="search" />}
							bordered={true}
						/>
						<Button
							onClick={() => setResolveModal(true)}
							style={{
								display: `${selectedRowIDs.length ? "flex" : "none"}`,
								alignItems: "center",
								padding: "8px 16px",
								color: "#fec708",
								fontSize: "16px",
								lineHeight: "24px",
								background: "#FFFFFF",
								border: "1px solid #fec708",
								borderRadius: "4px",
								height: "40px",
								marginRight: "14px",
							}}>
							<Icon
								type="check"
								style={{
									height: "16px",
								}}
							/>
							Mark All Resolved
						</Button>
						<Modal visible={resolveModal} destroyOnClose maskClosable={false} onCancel={() => setResolveModal(false)} footer={null}>
							<Row className="modal-row">
								<Row>
									<Icon
										type="check"
										style={{
											color: "#181818",
											fontSize: "24px",
											marginRight: "16px",
										}}
									/>
									<Text
										style={{
											fontWeight: "bold",
											color: "#181818",
											fontSize: "24px",
										}}>
										Mark All Resolved
									</Text>
								</Row>
								<Row style={{ marginTop: "30px" }}>
									<Col span={24}>
										<div>
											<Text
												style={{
													fontSize: "14px",
													color: "#181818",
												}}>
												Are You sure you want to mark all selected card link requests as resolved?
											</Text>
										</div>
									</Col>
								</Row>
								<Row style={{ marginTop: "30px" }}>
									<Col span={24} style={{ textAlign: "right" }}>
										<Button
											onClick={() => {
												resolveInaamCardLinkRequestApi({
													requestData: {
														card_link_requests_uuid: selectedRowIDs,
														status: "resolved"
													},
													res200Callback: () => {
														setResolveModal(false);
														fetchInaamCardLinkRequestList();
													},
												});
											}}
											size={"large"}
											style={{
												backgroundColor: "#fec708",
												color: "#FFFFFF",
												border: "none",
												borderRadius: "4px",
											}}>
											Mark as Resolved
										</Button>
									</Col>
								</Row>
							</Row>
						</Modal>
						<Button
							onClick={() => setExportReportModal(true)}
							style={{
								display: "flex",
								alignItems: "center",
								padding: "8px 16px",
								color: "#FFFFFF",
								fontSize: "16px",
								lineHeight: "24px",
								background: "#fec708",
								borderRadius: "4px",
								height: "40px",
							}}>
							<Icon
								type="export"
								style={{
									height: "16px",
								}}
							/>
							Export Report
						</Button>
						<Modal visible={exportReportModal} destroyOnClose maskClosable={false} onCancel={() => setExportReportModal(false)} footer={null}>
							<Row className="modal-row">
								<Row>
									<Icon
										type="export"
										style={{
											color: "#181818",
											fontSize: "24px",
											marginRight: "16px",
										}}
									/>
									<Text
										style={{
											fontWeight: "bold",
											color: "#181818",
											fontSize: "24px",
										}}>
										Export Report
									</Text>
								</Row>
								<Row style={{ marginTop: "30px" }}>
									<Col span={24}>
										<div>
											<Text
												style={{
													fontSize: "14px",
													color: "#181818",
												}}>
												Select Date Range
											</Text>
											<RangePicker
												style={{
													marginTop: "5px",
													width: "100%",
													border: "1px solid rgb(0, 0, 0, 0.25)",
													borderRadius: "4px",
													alignItems: "left",
												}}
												bordered={true}
												value={[
													exportReportDate.start_date ? moment(exportReportDate.start_date, "YYYY-MM-DD") : null,
													exportReportDate.end_date ? moment(exportReportDate.end_date, "YYYY-MM-DD") : null,
												]}
												onChange={(value, dateString) => {
													setExportReportDate({ start_date: dateString[0] || "", end_date: dateString[1] || "" });
												}}
											/>
										</div>
									</Col>
								</Row>
								<Row style={{ marginTop: "30px" }}>
									<Col span={24} style={{ textAlign: "right" }}>
										<Button
											onClick={() => {
												createReport();
											}}
											size={"large"}
											style={{
												backgroundColor: "#fec708",
												color: "#FFFFFF",
												border: "none",
												borderRadius: "4px",
											}}>
											Export Report
										</Button>
									</Col>
								</Row>
							</Row>
						</Modal>
					</div>
				</Row>
				<Tabs
					onChange={(key) => {
						activeKey.current = key;
						fetchInaamCardLinkRequestList();
					}}
					style={{ marginBottom: "20px" }}>
					<TabPane tab={`In Queue (${cardLinkStats.pending})`} key="1">
						<CardComplaintsTable
							data={pendingData}
							updatePage={(pageNum) => {
								pageNum === pendingData.pageNum ? fetchInaamCardLinkRequestList() : setPendingData({ ...pendingData, pageNum: pageNum });
							}}
							loading={tableLoading}
							handleRowSelection={handleRowSelection}
						/>
					</TabPane>
					<TabPane tab={`Resolved (${cardLinkStats.resolved})`} key="2">
						<CardComplaintsTable
							data={resolvedData}
							updatePage={(pageNum) => {
								pageNum === resolvedData.pageNum ? fetchInaamCardLinkRequestList() : setResolvedData({ ...resolvedData, pageNum: pageNum });
							}}
							loading={tableLoading}
							noAction={true}
						/>
					</TabPane>
				</Tabs>
			</Row>
		</>
	);
}
